import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, Table, Grid } from 'semantic-ui-react';
import { Helmet } from "react-helmet";


import CustomDivider from '../../components/extras/CustomDivider';
import ChartExpense from '../../components/charts/ChartExpense';
import FilterBar from '../../components/reports/FilterBar';
import AlertUpgrade from "../../components/extras/AlertUpgrade";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";

class ExpenseTypes extends Component {
    loadData = (branch_office, date) => {
        if (!localDB.checkPlanAccessExclude('reports_view_all')) {
            this.refs.expenses_day_chart.loadData(branch_office, 'd', date);
            this.refs.expenses_week_chart.loadData(branch_office, 'w', date);
            this.refs.expenses_month_chart.loadData(branch_office, 'm', date);
            this.refs.expenses_year_chart.loadData(branch_office, 'y', date);
        } else {
            this.refs.alert_upgrade.open();
        }
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Tipos de Gasto - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section active>Tipos de Gasto</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider />
                {!localDB.checkPlanAccessExclude('ticket_service') ? <Table>
                    <FilterBar title='Tipos de Gasto' callbackGetFilter={this.loadData} download={true} url_download='reports/expense-types'/>
                    <Table.Body>
                        <Table.Row>
                            <Grid stackable textAlign='center'>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <ChartExpense
                                            title='Gastos por Día'
                                            id='expenses_day_chart'
                                            ref='expenses_day_chart'
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <ChartExpense
                                            title='Gastos por Semana'
                                            id='expenses_week_chart'
                                            ref='expenses_week_chart'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <ChartExpense
                                            title='Gastos por Mes'
                                            id='expenses_month_chart'
                                            ref='expenses_month_chart'
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <ChartExpense
                                            title='Gastos por Año'
                                            id='expenses_year_chart'
                                            ref='expenses_year_chart'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Table.Row>
                    </Table.Body>
                </Table> : <UpgradeAccount />}
                <AlertUpgrade ref='alert_upgrade' />
            </div>
        );
    }
}

export default ExpenseTypes;



// WEBPACK FOOTER //
// ./src/containers/reports/ExpenseTypes.js